import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [logoError, setLogoError] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    // Check initial scroll position
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav 
      className={`w-full px-4 sm:px-8 lg:px-6 xl:px-8 text-white z-50 shadow-xl transition-all duration-300 ${
        isScrolled ? 'fixed top-0 bg-black' : 'absolute top-0 bg-transparent'
      }`}
    >
      <div className="max-w-[1000px] mx-auto flex items-center justify-between py-2 lg:py-0">
        
        {/* Mobile Menu Button */}
        <button 
          onClick={toggleMobileMenu}
          className="lg:hidden text-white p-2"
          aria-label="Toggle mobile menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMobileMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        {/* Left Navigation - Desktop Only */}
        <div className="hidden lg:flex items-center">
          <Link to="/" className="text-white mr-8 hover:text-logo-green font-medium text-sm  transition-colors duration-200">
            Home
          </Link>
          <Link to="/booknow" className="text-white mr-8 hover:text-logo-green font-medium text-sm  transition-colors duration-200">
            Book Now
          </Link>
          <Link to="/about" className="text-white mr-8 hover:text-logo-green font-medium text-sm  transition-colors duration-200">
            About
          </Link>
          <Link to="/services" className="text-white  hover:text-logo-green font-medium text-sm  transition-colors duration-200">
            Our Services
          </Link>
        </div>

        {/* Center Logo - Responsive */}
        <div className="relative flex-1 lg:flex-none flex justify-center lg:mx-1">
          {/* Background circle - responsive - only show when scrolled */}
          {isScrolled && (
            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-[220px] lg:h-[220px] rounded-full  bg-black"></div>
            </div>
          )}
          
          {/* Logo Container */}
          <div className="relative z-10 mt-4 sm:mt-6 lg:mt-8">
            <Link to="/">
              {logoError ? (
                // Fallback text logo - responsive
                <div className="flex flex-col items-center justify-center">
                  <span className="text-xs sm:text-sm lg:text-base font-semibold text-white tracking-[0.2em]">
                    ATL AIRPORTS
                  </span>
                  <span className="text-lg sm:text-2xl lg:text-4xl font-black text-white -mt-1 lg:-mt-2">
                    LIMO
                  </span>
                </div>
              ) : (
                // Image logo - responsive
                <img 
                  src="/mvu.png" 
                  alt="ATL Airports Limo"
                  className="h-12 sm:h-16 lg:h-20 w-auto"
                  onError={() => setLogoError(true)}
                />
              )}
            </Link>
          </div>
        </div>

        {/* Right Navigation - Desktop Only */}
        <div className="hidden lg:flex items-center">
          <Link to="/fleet" className="text-white mr-8 hover:text-logo-green font-medium text-sm  transition-colors duration-200">
            Our Fleet
          </Link>
          <Link to="/blog" className="text-white mr-8 hover:text-logo-green font-medium text-sm  transition-colors duration-200">
            Blogs
          </Link>
          <Link to="/cities" className="text-white mr-8 hover:text-logo-green font-medium text-sm transition-colors duration-200">
            Cities We Serve
          </Link>
          <Link to="/contact" className="text-white  hover:text-logo-green font-medium text-sm  transition-colors duration-200">
            Contact Us
          </Link>
        </div>

        {/* Mobile Contact Button */}
        <div className="lg:hidden">
          <a 
            href="tel:+17182004140" 
            className="text-white p-2 hover:text-logo-green transition-colors"
            aria-label="Call us"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </a>
        </div>

      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div 
          className={`lg:hidden border-t border-gray-800 transition-all duration-300 ${
            isScrolled ? 'bg-black' : 'bg-black/80 backdrop-blur-sm'
          }`}
        >
          <div className="px-4 py-4 space-y-3">
            <Link 
              to="/" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/booknow" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Book Now
            </Link>
            <Link 
              to="/about" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Our Services
            </Link>
            <Link 
              to="/fleet" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Our Fleet
            </Link>
            <Link 
              to="/blog" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Blogs
            </Link>
            <Link 
              to="/cities" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Cities We Serve
            </Link>
            <Link 
              to="/contact" 
              className="block text-white hover:text-logo-green font-medium py-2 transition-colors duration-200"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact Us
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;